var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtLink',{staticClass:"group relative block h-full",attrs:{"to":_vm.localePath(
      _vm.brand.url
        ? {
            name: 'brand-lister-all',
            params: { pathMatch: _vm.brand.url },
          }
        : {
            name: 'index',
          }
    )}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.brand.img),expression:"brand.img"}],staticClass:"brand-item-img w-full h-full object-contain transition-all duration-300 ease-in-out group-hover:opacity-0",attrs:{"width":"171","height":"117","alt":_vm.brand.name},on:{"error":function($event){_vm.hasImage = false}}}),_vm._v(" "),_c('p',{staticClass:"absolute inset-0 flex items-center justify-center text-center leading-tight text-black font-bold capitalize transition-all duration-300 ease-in-out group-hover:opacity-100",class:{ 'opacity-0': _vm.hasImage }},[_vm._v("\n    "+_vm._s(_vm.brand.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }